const unlockedFeaturesDialogDataset = [
// treat these as separate attributes
      {featureName: "setupSavings", policy: "new", commentTable: [
            {friendName:"Jennifer",  comment:"I don't know what to tell you. " +
                  "I don't really know much about this stuff.  But I guess it would be " +
                  "cool to earn some interest on money if you have any extra each month."},
            {friendName:"Charlie", comment: "I am still trying to figure this out for myself. " +
                  "I like the CDs but I don't know if I can commit to putting " +
                  "money away for a full year."}, 
            {friendName:"Cindy", comment: "You should save as much as you can. But, be careful. " +
                  "Don't put too much in savings like CD's if you can't afford to leave it there until " +
                  "it matures. " 
            },
            {friendName:"Cameron", comment: "Why would you want to save money? " +
                  "Just think of all the fun things you can do or the things you can buy if you spend " +
                  "the money instead of saving it." }]
      },

      {featureName: "setup401K", policy: "new", commentTable: [
            {friendName:"Jennifer",  comment: "Heck, I don't know, I guess you should put as much " +
                  "as you can in the 401(k) high-risk 'thing'. I mean, the possible earnings are " +
                  "really impressive , right?."
            },
            {friendName:"Charlie", comment: "Wow! Your company has a 401(k) match program.  That means " +
                  "they are sort of paying you to save....Very Cool! "}, 
            {friendName:"Cindy", comment: "You should save as much as you can. But, be careful. " +
                  "Don't put too much in a 401(k) because you need to have enough " +
                  "cash and short-term savings to cover unexpected expenses." 
            },
            {friendName:"Cameron", comment: "A 401(k) is a retirement account.  Why would " +
                  "you want to start a retirement account now?  Perhaps when you get a lot " +
                  "older, that might make sense." }]
      },

      {featureName: "setupInvestments", level: "", commentTable: [
            {friendName: "Jennifer", comment: 
            "I’ve heard people make a lot of money with stocks, but it seems kind of scary. " +
            "Index funds and mutual funds sound more chill — like less risky, I guess? I wouldn't " +
            "waste my money on bonds - not much of a return."},

            {friendName: "Charlie", comment: 
            "I’m learning that bonds are usually safer than stocks, but they don’t make as much. " +
            "Index funds and mutual funds seem like a good way to spread out your risk. I might try " +
            "one of those."},

            {friendName: "Cindy", comment: 
            "Be careful with stocks — they can be risky, especially if you’re planning to use that money " +
            "soon. If you want to invest, index or mutual funds are safer bets since they’re diversified. " +
            "Bonds are good if you want more stability."},

            {friendName: "Cameron", comment: 
            "You could totally get rich with stocks, right? Like, if you pick the right one, boom! " +
            "I don’t really get bonds — they sound boring. I say go big or go home!"}]
      },

      
      {featureName: "setupCreditCard", level: "", commentTable: [
            {friendName:"Jennifer",  comment:"I don't know much about credit cards " +
            "except they let you buy a lot of things and put off paying for them. " +
            "I just pay the minimum amount each month."},
            {friendName:"Charlie", comment: "I think you should definitely sign up for a credit card. " +
            "I have one and the statements let me see exactly how I'm spending my money."}, 
            {friendName:"Cindy", comment: "Credit cards are great, but you really " +
            "should pay off the full balance each month.  Otherwise, you end up paying a lot " +
            "extra in interest on the unpaid amounts." },
            {friendName:"Cameron", comment: "Now we're talking!!  With a credit card you can buy " +
            "things you can't really afford.  As long as they cost less than your maximum " +
            "credit amount, you can just put it on the card!!!  Ya Hoo!!! "}]
      },
   
   
];

export default unlockedFeaturesDialogDataset;